/* @flow */
export const CARIBBEAN = '#5fc4bb';
export const CARIBBEAN_RGB = '95, 196, 187';
export const MIDNIGHT = '#182947';
export const BRAND = '#2f75c1';
export const SKY = '#23c4ed';
export const VIOLET = '#5d60a5';
export const VIOLET_RGB = '93, 96, 165';

export const PITCH = '#282c31';
export const THUNDER = '#6b6e72';
export const POLAR_BEAR = '#f2f3f5';

export const CHART_ACTIVE_DOT_RADIUS = 8;
export const CHART_AREA_FILL_OPACITY = 0.9;
export const CHART_AXIS_FILL = THUNDER;
export const CHART_BAR_SIZE = 50;
export const CHART_GRID_COLOR = POLAR_BEAR;
export const CHART_HEIGHT = 300;
export const CHART_HEIGHT_SIMPLE = 180;
export const CHART_LEGEND_ALIGN = 'left';
export const CHART_LEGEND_ICON_SIZE = 12;
export const CHART_LINE_STROKE_WIDTH = 3;
export const CHART_MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };
export const CHART_MARKER_TYPE = 'monotone';
export const CHART_MARKER_LEGEND_TYPE = 'circle';
export const CHART_REFERENCE_LINE_STROKE = VIOLET;
export const CHART_REFERENCE_LINE_STROKE_DASHARRAY = '10 8';
export const CHART_REFERENCE_LINE_STROKE_WIDTH = 2;
export const CHART_X_AXIS_PADDING = 50;
